import { render, staticRenderFns } from "./RoomLabel.vue?vue&type=template&id=b1aeab66"
import script from "./RoomLabel.vue?vue&type=script&lang=js"
export * from "./RoomLabel.vue?vue&type=script&lang=js"
import style0 from "./RoomLabel.vue?vue&type=style&index=0&id=b1aeab66&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports